<template>
  <div class="xieyi">
    <div class="title">人人动画网素材及作品授权及购买协议</div>
    <div class="fir">
      人人动画网站内所有素材（模型、动作、音效）及作品均由人人动画网或会员发布生成，内容包括但不限于图片、视频、动图、模型等，以下统一简称“素材”或“作品”。您从人人动画网付费下载“素材”或“作品”，即表示您接受本协议的条款。
    </div>

    <div class="f-tit">您的权利和义务：</div>
    <p>1. 您通过人人动画网付费购买的“素材”或“作品”，代表您已获得该付费“素材”或“作品”的使用权，且该使用权永久有效。</p>
    <p>2. 您通过人人动画网付费购买的“素材”或“作品”原始版本版权归人人动画网或原作者所有，未经人人动画网或原作者同意禁止任意转载至其它网站。</p>
    <p>3. 您通过人人动画网付费购买的“素材”或“作品”如需商业使用，需获得人人动画网或版权拥有者授权，并遵循国家相关法律、法规之规定。如因非法使用引起纠纷，一切后果由使用者承担。</p>
    <p>4. 您通过人人动画网付费购买的“素材”或“作品”不得用于色情、诽谤或其他非法方式使用，不得用于商标或标志。</p>
    <p>5. 您通过人人动画网获得授权“素材”或“作品”不得再进行转授权。即您不得以任何形式允许其他人下载、选取局部、修改或重新分发的方式使用。</p>
    <div class="f-tit">人人动画网的权利和义务：</div>
    <p>1. 人人动画网作为为注册用户提供“素材”或“作品”网络交易平台及信息存储空间的服务商，通过发布约定和人工审核剔除盗版行为，但对非法转载，盗版行为的发生不具备充分的监控能力。</p>
    <p>2. 人人动画网有义务协助版权拥有者维护版权利益，如果版权拥有者发现自己作品在使用时违反本协议中使用约定，人人动画网或版权拥有者有权要求侵权人赔偿。</p>
    <p>3. 人人动画网有义务协助付费用户因非法转载及盗版行为带来的损失进行追偿。</p>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  components: {

  },
  data () {
    return {

    }
  }
}
</script>

<style scoped lang="less">
.xieyi{
  line-height: 30px;
  font-size: 14px;
  .title{
    margin-bottom: 20px;
    font-size: 30px;
    text-align: center;
    font-weight: bold;
  }
  .fir{
    text-indent: 28px;
    font-size: 16px;
    font-weight: bold;
  }
  .f-tit{
    margin: 10px 0 5px;
    font-size: 16px;
    text-indent: 28px;
    font-weight: bold;
  }
  p{
    margin: 5px 0;
    line-height: 24px;
    text-indent: 28px;
    &.p{
      margin: 10px 0;
      font-size: 15px;
      font-weight: bold;
    }
  }
}
@media screen and (min-width: 751px) {
  .xieyi{
    padding: 0 40px;
  }
}
@media screen and (min-width: 1370px) {
  .xieyi{
    padding: 0 80px;
  }
}
</style>
